import React, { useState } from 'react'
import styles from "./Templatepage.module.css"
import { systemProps } from '@chakra-ui/react'

const TemplateModal = ({ setShowModal, currentItem }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [thumbnailStartIndex, setThumbnailStartIndex] = useState(0);

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);

        // Slide thumbnails if clicked index is outside the visible 2
        if (index < thumbnailStartIndex) {
            setThumbnailStartIndex(index); // move start index to clicked one
        } else if (index >= thumbnailStartIndex + 2) {
            setThumbnailStartIndex(index - 1); // shift window so clicked thumbnail is visible
        }
    };

    console.log(currentItem);
    return (
        <div className={styles.template_modal_outer}>
            <div className={styles.modal_close}>
                <button onClick={() => setShowModal(false)}>Close</button>
            </div>

            <div className={styles.template_modal_inner}>
                <div className={styles.template_modal_image}>
                    {currentItem?.previews && currentItem?.previews.length > 0 ? (
                        <div style={{ height: "100%", maxHeight: "800px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "20px" }}>
                            <img
                                style={{ height: "auto", maxHeight: "300px", width: "auto", }}
                                src={`data:image/jpeg;base64,${currentItem?.previews[currentImageIndex]}`}
                                alt={`template ${currentImageIndex + 1}`}
                            />
                            {currentItem.previews.length > 1 && (
                                <div className={styles.thumbnail_container}>
                                    {currentItem.previews
                                        .slice(thumbnailStartIndex, thumbnailStartIndex + 2) // only show 2 thumbnails
                                        .map((img, index) => {
                                            const actualIndex = thumbnailStartIndex + index;
                                            return (
                                                <img
                                                    key={actualIndex}
                                                    src={`data:image/jpeg;base64,${img}`}
                                                    alt={`thumb ${actualIndex + 1}`}
                                                    className={`${styles.thumbnail} ${actualIndex === currentImageIndex ? styles.active_thumbnail : ""
                                                        }`}
                                                    onClick={() => handleThumbnailClick(actualIndex)}
                                                />
                                            );
                                        })}
                                </div>
                            )}
                        </div>
                    ) : (
                        <p>No image available</p>
                    )}
                </div>

                <div className={styles.template_modal_content}>
                    <h1 className={styles.heading}>{currentItem.name}</h1>
                    <p>{currentItem.description}</p>
                </div>
            </div>
        </div >

    )
}

export default TemplateModal